import { AnimateSlideInContent } from '@components/animation/AnimateSlideIn/index.style'
import { clamp } from '@styles/utils/conversion.style'
import { breakpoints } from '@styles/vars/breakpoints.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import { Heading1Serif } from '@styles/vars/textStyles.style'
import { roundedCorners } from '@utils'
import styled from 'styled-components'

export const HeroMain = styled.div`
  color: ${props => props.tColor ? props.tColor : colors.white};
  background-color: ${props => props.bgColor ? props.bgColor : colors.charcoal};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  .caption {
    margin-top: auto;
    display: flex;
    font-size: 21px;
  }
  .content {
    ${clamp('min-height', 350, 500)};
    position: relative;
    order: 1;
    display: flex;
    flex-flow: column;
    ${mq.tabletPMax} {
      justify-content: flex-end;
    }
  }
`

export const HeroRow = styled.div`
  ${mq.tabletL} {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
`

export const HeroImage = styled.div`
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:after {
    display: ${props => props.overlay ? '' : 'none'};
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 50%);
  }
  .gatsby-image-wrapper {
    width: 100%;
    min-height: 100%;
    position: absolute;
    ${mq.tabletL} {
        height: 100%;
    }
  }
`
export const LogoContainer = styled.div`
  ${clamp('width', 118, 150)}
  margin-right: 10px;
`